// TODO: merge with good-examples.js

// with JS available, list is automatically updated. so on clicking the update button, we just scroll to the top of the list
document.querySelector('.koha input[type=submit]').addEventListener('click', function (e) {
	e.preventDefault();
	document.querySelector('.koha .mainbar').scrollIntoView();
	window.scrollBy(0, -1 * document.querySelector('.hdr').offsetHeight - 8); // compensate for fixed header
});

// assign event handlers to filter
const setFilterEvents = () => {
	document.querySelectorAll('.koha form input[type=checkbox]').forEach(input => input.addEventListener('change', changeFilter));
}

// filter has changed
const changeFilter = () => {
	const formdata = new FormData(document.querySelector('.koha form'));
	window.history.pushState(
		null,
		'',
		`?${new URLSearchParams(formdata)}`
	);
	getPage(window.location.href);
}

const getPage = url => {
	fetch(url).then(response => response.text()).then(updateView);
}

// update page with new contents
const updateView = contents => {
	const newdom = new DOMParser().parseFromString(contents, 'text/html');
	document.getElementById('reports').outerHTML = newdom.getElementById('reports').outerHTML;
	setIcons(document.getElementById('reports')); // reapply icons on new contents
	document.getElementById('pager').outerHTML = newdom.getElementById('pager').outerHTML;
	setIcons(document.getElementById('pager')); // reapply icons on new contents
	// rejected: update page title (because multiple themes may be selected)
	setFilterEvents(); // must be reapplied, because we replaced the input labels
}

window.addEventListener('popstate', () => {
	getPage(window.location.href);
})

setFilterEvents();
